import "../../js/helper/Helper.Url.js";

const HelperUrlObject: typeof HelperUrl = window.Helper.Url;

export {HelperUrlObject as HelperUrl};